import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import Reload from "../../components/Reload/Reload";
import ApiMServer from "../../services/ApiMServer";
import ApiGServer from "../../services/ApiGServer";
import Grafico from "./components/Grafico";

const Telemetria = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [company, setCompany] = useState({});
  const [progress, setProgress] = useState(0);
  const [reload, setReload] = useState(false);
  const [detailsEquip, setDetailsEquip] = useState([]);
  const [filteredEquipments, setFilteredEquipments] = useState([]);

  const reloadRef = useRef(reload);

  const handleCompany = useCallback(async () => {
    try {
      let { data } = await ApiMServer.post(`/company/detail`, { id });
      
      if (data) {
        setCompany(data);
        localStorage.setItem('company', JSON.stringify(data));
        
        if (data?.equipments?.length) {
          let equipments = data.equipments.filter(equip =>
            equip != null && (equip.includes("SIMT") || equip.includes("SEMT") || equip.includes("BIMT"))
          );
          
          if (equipments.length > 0) {
            setFilteredEquipments(equipments);

            let equip = await ApiGServer.post(`equipment/filter`, { filter: equipments });
            if (equip?.data) {
              setDetailsEquip(equip.data);
            }
          } else {
            setFilteredEquipments([]);
            setDetailsEquip([]);
          }
        } else {
          setFilteredEquipments([]);
          setDetailsEquip([]);
        }
      }
    } catch (error) {
      console.error('Erro ao buscar dados da empresa:', error?.message);
      // Mantém os dados anteriores em caso de erro de rede
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    let isMounted = true;
    
    // Executa apenas se o componente estiver montado
    if (isMounted) {
      handleCompany();
    }
    
    //----------------------------------------------------------------------
    const progressInterval = setInterval(() => {
      if (isMounted) {
        setProgress((prev) => {
          if (prev >= 100) {
            const currentReload = reloadRef.current;
            setReload(!currentReload);
            return 0;
          }
          return prev + 3.33;
        });
      }
    }, 1000);

    const companyInterval = setInterval(() => {
      if (isMounted) {
        handleCompany();
      }
    }, 300000); // 5 minutos (300000ms)

    return () => {
      isMounted = false;
      clearInterval(progressInterval);
      clearInterval(companyInterval);
    };
  }, [handleCompany]);

  useEffect(() => {
    reloadRef.current = reload;
  }, [reload]);

  // Previne que a página entre em modo de economia de energia
  useEffect(() => {
    let wakeLock = null;

    // Tenta manter a tela ativa (se suportado pelo navegador)
    const requestWakeLock = async () => {
      try {
        if ('wakeLock' in navigator) {
          wakeLock = await navigator.wakeLock.request('screen');
        }
      } catch (err) {
        console.log('Wake Lock não suportado:', err);
      }
    };

    requestWakeLock();

    // Reativa o wake lock se a página voltar a ser visível
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && wakeLock === null) {
        requestWakeLock();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (wakeLock !== null && wakeLock !== undefined && typeof wakeLock.release === 'function') {
        wakeLock.release().then(() => {
          wakeLock = null;
        }).catch(() => {
          // Ignora erros ao liberar wake lock
        });
      }
    };
  }, []);

  return (
    <Container className="pt-2" style={{ background: '#1c4220', minHeight: "100vh" }} fluid>
      {isLoading && <Reload />}
      <Row className="mb-2 g-2">
        <Col>
          <div style={{
            width: '100%',
            backgroundColor: '#f4f4f4',
            borderRadius: '5px',
            border: "solid 1px #f4f4f4",
            overflow: 'hidden'
          }}>
            <div
              style={{
                width: `${Math.min(progress, 100)}%`,
                height: 8,
                backgroundColor: '#1c4220',
                borderRadius: '5px',
                transition: 'width 1s linear',
              }}
            ></div>
          </div>
        </Col>
      </Row>
      <Row className="g-2">
        {detailsEquip?.length && filteredEquipments?.map((serial) => (
          <Grafico
            key={serial}
            company={company}
            serial={serial}
            reload={reload}
            detailsEquip={detailsEquip}
            totalEquipments={filteredEquipments.length}
          />
        ))}
      </Row>
    </Container>
  );
};

export default Telemetria;
